import { useCallback, useMemo } from "react";

import { useHeaderPriorityStore } from "@faire/retailer/components/HeaderPriorityRenderer/HeaderPriorityPriovider";

export enum HeaderDropdownType {
  ACCOUNT = "ACCOUNT",
  NOTIFICATIONS = "NOTIFICATIONS",
  CATEGORIES = "CATEGORIES",
  LANGUAGE_SELECTOR = "LANGUAGE_SELECTOR",
}

export const useIsHeaderDropdownVisible = () => {
  const [{ isHeaderDropdownVisibleMap }, setHeaderPriorityStore] =
    useHeaderPriorityStore(["isHeaderDropdownVisibleMap"]);

  const setHeaderDropdownVisibility = useCallback(
    (dropdown: keyof typeof HeaderDropdownType, isVisible: boolean) => {
      setHeaderPriorityStore((prevState) => {
        return {
          ...prevState,
          isHeaderDropdownVisibleMap: {
            ...prevState.isHeaderDropdownVisibleMap,
            [dropdown]: isVisible,
          },
        };
      });
    },
    [setHeaderPriorityStore]
  );

  const getHeaderDropdownVisibility = useCallback(
    (dropdown: keyof typeof HeaderDropdownType) =>
      isHeaderDropdownVisibleMap[dropdown],
    [isHeaderDropdownVisibleMap]
  );

  const isAnyHeaderDropdownVisible = useMemo(
    () =>
      Object.values(isHeaderDropdownVisibleMap).some((isVisible) => isVisible),
    [isHeaderDropdownVisibleMap]
  );

  return {
    setHeaderDropdownVisibility,
    getHeaderDropdownVisibility,
    isAnyHeaderDropdownVisible,
  };
};
